export default "__VITE_ASSET__DIG6MXyx__"